import { render, staticRenderFns } from "./StudentEditForm.vue?vue&type=template&id=2fa6f0da&"
import script from "./StudentEditForm.vue?vue&type=script&lang=js&"
export * from "./StudentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports